import { useMemo } from "react";
import { useData } from "data/data-provider";
import { tierSlots, TierSlots } from "utils/tierSlots";

/** The slots for this car's card: the whole fleet's, and always at least what this car shows. */
export const useTierSlots = (car: any): TierSlots => {
  const { ourVehicles, ourCompany } = useData();
  const fleet = useMemo(() => tierSlots(ourVehicles, ourCompany), [ourVehicles, ourCompany]);
  const own = tierSlots([car], ourCompany);
  return { rows: Math.max(fleet.rows, own.rows), more: fleet.more || own.more, request: !!(fleet.request || own.request) };
};
